<script>
/**
 * WatchlistSuccessModal — the "Documents Uploaded Successfully" confirmation shown after a
 * clear or block. Copy differs by mode, matching the mockups.
 */
export default {
  name: "WatchlistSuccessModal",
  props: {
    value: { type: Boolean, default: false },
    // 'clear' | 'block'
    mode: { type: String, default: "clear" },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    message() {
      return this.mode === "block"
        ? "The supporting documents have been uploaded successfully. The merchant KYC has been failed and blocked to the watchlist."
        : "The supporting documents have been uploaded successfully. The merchant KYC has been approved and cleared to the watchlist.";
    },
  },
  methods: {
    onOk() {
      this.show = false;
      this.$emit("ok");
    },
  },
};
</script>

<template>
  <b-modal v-model="show" size="md" centered hide-header hide-footer no-close-on-backdrop>
    <div class="wl-success text-center">
      <div class="wl-check">
        <i class="bx bx-check"></i>
      </div>
      <h5 class="fw-bold mt-3 mb-2">Documents Uploaded Successfully</h5>
      <p class="text-muted mb-4">{{ message }}</p>
      <b-button type="button" class="wl-ok-btn" @click="onOk">OK</b-button>
    </div>
  </b-modal>
</template>

<style scoped>
.wl-success {
  padding: 1.5rem 1.5rem 1rem;
}
.wl-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 84px;
  height: 84px;
  border-radius: 50%;
  border: 3px solid #7ac77a;
  margin: 0 auto;
}
.wl-check .bx {
  font-size: 48px;
  color: #4caf50;
}
.wl-ok-btn {
  background-color: #6f5bd1;
  border-color: #6f5bd1;
  color: #fff;
  min-width: 90px;
}
</style>
